// vuex配置文件
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 全局共享数据
  state: {
    pushInfoList: [],

    quetionDataList: []
  },
  // 变更state内数据
  mutations: {
    changePushInfoList(state, data) {
      state.pushInfoList.push(data)
    },
    updataQuetionDataList(state, data) {
      state.quetionDataList = data
    }
  },
  actions: {}
})



// WEBPACK FOOTER //
// ./src/store.js